import { Maybe } from '../../../__generated__/globalTypes'

import {
  UserSettingsFragment,
  isUserSettingsFragment,
} from './UserSettingsFragment'

import { AddressFragment, isAddressFragment } from './AddressFragment'

import { Storefront, isStorefront } from './Storefront'

import { StripeSubscription, isStripeSubscription } from './StripeSubscription'

import { SponsorFragment, isSponsorFragment } from './SponsorFragment'

import { ExpenseReload, isExpenseReload } from './ExpenseReload'

import { Amount, isAmount } from './Amount'

import {
  StripeSourceFragment,
  isStripeSourceFragment,
} from './StripeSourceFragment'

import { PlanFragment, isPlanFragment } from './PlanFragment'

import accountFragmentRawString from '../AccountFragment.graphql'

export const accountFragmentString = accountFragmentRawString

export type AccountFragment = {
  id: string
  username: string
  firstName: string
  lastName: string
  email: string
  profileImageUrl: Maybe<string>
  isStaff: boolean
  isDistributor: boolean
  isNewUser: boolean
  genealogyId: number
  stripeCustomerId: Maybe<string>
  groupSends: number
  loyaltyRewards: number
  scheduledSends: number
  systemSends: number
  heartfeltSends: number
  pointPrice: number
  token: string
  settings: Maybe<UserSettingsFragment>
  shippingAddress: Maybe<AddressFragment>
  sponsor: Maybe<SponsorFragment>
  storefront: Maybe<Storefront>
  plan: PlanFragment
  stripeSource: Maybe<StripeSourceFragment>
  stripeSubscription: Maybe<StripeSubscription>
  subscriptions: StripeSubscription[]
  points: Amount
  expense: Amount
  expenseReload: Maybe<ExpenseReload>
}

export const isAccountFragment = (fragment: any): fragment is AccountFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.username === 'string' &&
  typeof fragment.firstName === 'string' &&
  typeof fragment.lastName === 'string' &&
  typeof fragment.email === 'string' &&
  (fragment.profileImageUrl === null ||
    typeof fragment.profileImageUrl === 'string') &&
  typeof fragment.isStaff === 'boolean' &&
  typeof fragment.isDistributor === 'boolean' &&
  typeof fragment.isNewUser === 'boolean' &&
  typeof fragment.genealogyId === 'number' &&
  (fragment.stripeCustomerId === null ||
    typeof fragment.stripeCustomerId === 'string') &&
  typeof fragment.groupSends === 'number' &&
  typeof fragment.loyaltyRewards === 'number' &&
  typeof fragment.scheduledSends === 'number' &&
  typeof fragment.systemSends === 'number' &&
  typeof fragment.heartfeltSends === 'number' &&
  typeof fragment.pointPrice === 'number' &&
  typeof fragment.token === 'string' &&
  (fragment.settings === null ||
    (isUserSettingsFragment(fragment.settings) as boolean)) &&
  (fragment.shippingAddress === null ||
    (isAddressFragment(fragment.shippingAddress) as boolean)) &&
  (fragment.sponsor === null ||
    (isSponsorFragment(fragment.sponsor) as boolean)) &&
  (fragment.storefront === null ||
    (isStorefront(fragment.storefront) as boolean)) &&
  (isPlanFragment(fragment.plan) as boolean) &&
  (fragment.stripeSource === null ||
    (isStripeSourceFragment(fragment.stripeSource) as boolean)) &&
  (fragment.stripeSubscription === null ||
    (isStripeSubscription(fragment.stripeSubscription) as boolean)) &&
  Array.isArray(fragment.subscriptions) &&
  fragment.subscriptions
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (isStripeSubscription(next) as boolean),
      true,
    ) &&
  (isAmount(fragment.points) as boolean) &&
  (isAmount(fragment.expense) as boolean) &&
  (fragment.expenseReload === null ||
    (isExpenseReload(fragment.expenseReload) as boolean))
